import React from 'react';

import { getQcScoreToneClasses } from '@/pages/qc/qcDetail.utils';
import { formatAggregateScore } from '@/pages/qc/utils';
import { cn } from '@/utils';

interface QcSectionScoreCardsProps {
  sections: Array<{
    title: string;
    score?: number;
    scoredCount: number;
    sectionValue: string;
  }>;
  onSectionClick?: (sectionValue: string) => void;
}

export const QcSectionScoreCards: React.FC<QcSectionScoreCardsProps> = ({
  sections,
  onSectionClick,
}) => {
  if (sections.length === 0) {
    return null;
  }

  return (
    <div className="grid gap-2.5 md:grid-cols-3">
      {sections.map(section => (
        <div
          key={section.sectionValue}
          className={cn(
            'rounded-xl border border-border/70 bg-background px-4 py-3',
            onSectionClick && 'cursor-pointer hover:bg-muted/50',
          )}
          onClick={() => onSectionClick?.(section.sectionValue)}
        >
          <p className="text-sm font-medium text-muted-foreground">{section.title}</p>
          <p
            className={cn(
              'mt-1 text-xl font-semibold',
              section.score === undefined || section.score === null
                ? 'text-muted-foreground'
                : getQcScoreToneClasses(section.score),
            )}
          >
            {section.score === undefined || section.score === null
              ? '--'
              : formatAggregateScore(section.score)}
          </p>
          <p className="mt-0.5 text-xs text-muted-foreground">
            {section.scoredCount === 0 ? 'No Questions Activated' : `${section.scoredCount} scored`}
          </p>
        </div>
      ))}
    </div>
  );
};
